export default function Footer() {
  return (
    <footer className="bg-brand-primary py-12">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full border-2 border-white/40 flex items-center justify-center">
                <i className="ri-time-line text-white/80 text-lg" />
              </div>
              <span className="font-display text-xl font-semibold text-white">
                Apprendre
              </span>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm text-white/60">
              <a href="#accueil" className="hover:text-white transition-colors cursor-pointer">
                Accueil
              </a>
              <a href="#horloge" className="hover:text-white transition-colors cursor-pointer">
                Horloge
              </a>
              <a href="#jeu" className="hover:text-white transition-colors cursor-pointer">
                Jeu
              </a>
              <a href="#score" className="hover:text-white transition-colors cursor-pointer">
                Score
              </a>
            </div>

            {/* Copyright */}
            <p className="text-sm text-white/40">
              &copy; 2026 Apprendre
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}